import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  Renderer2,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms'
import { DateTime, Zone } from 'luxon';
import { GeneralService } from '../../../../services/general/general.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['../../../../../shared-styles/dashboard.scss','index.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class IndexComponent implements OnInit {
  
  public isMobile: any;
  public headerHeight: any = 0;
  public loading: any = false;
  public subscriptions: any = [];
  public testClasses = 0;
  public listedClasses : any;
  public lessons : any;
  public languages : any;
  // public filters: any;
  public active_filters: any = [];

  public filters = new FormGroup({
    lesson_id: new FormControl(''),
    date_start: new FormControl(''),
    date_end: new FormControl(''),
    language_id: new FormControl(''),
  });

  currentLocale: string | null;

  constructor(
    public general: GeneralService,
    private cdRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private formBuilder: FormBuilder,
    private _router: Router,
    private _route: ActivatedRoute,
    private http: HttpClient
  ) {
    this.isMobile = this.general.isMobile();
    this.currentLocale = this.general.getCurrentLocale();
    this.filters = this.formBuilder.group({
      lesson_id: ['0'],
      date_start: [null],
      date_end: [null],
      language_id: ['0'],   
    });
  }

  async ngOnInit() {
    try {
      this.general.setLoading(true);
      this.intializeSubscriptions();
      this.getGrupalClasses();
    } catch (error) {
      // teacher-class-mine
    } finally {
      this.general.setLoading(false);
      this.active_filters['lesson_id']='0';
      this.active_filters['lenguage_id']='0';
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: any) => {
      subscription.unsubscribe();
    });
  }

  intializeSubscriptions() {
    this.subscriptions = [
      this.general.loading$.subscribe((res) => (this.loading = res)),
    ]; 
    
  }
  
  async getGrupalClasses () {
    try {
      this.general.setLoading(true);
      const response = await this.general.httpPost('groupal-class-list',{});
      this.listedClasses = response.message;  

        //  -------------- 
    
        const key1 = 'lesson_id';
        
        this.lessons = [...new Map(this.listedClasses.map((item: { [x: string]: any; }) =>
          [item[key1], item])).values()];

          const key2 = 'language_id';
        
          this.languages = [...new Map(this.listedClasses.map((item: { [x: string]: any; }) =>
            [item[key2], item])).values()];        
        //  --------------
     
        this.listedClasses = this.listedClasses.map((e: any) => {
          const timezone = this.general.getCurrentTimezone();
          e.date = DateTime.fromFormat(e.dateHour,'yyyy-LL-dd HH:mm:ss',{zone: 'UTC',}).setZone(timezone);
          e.date = e.date.setLocale(this.currentLocale).toFormat('dd/MM/yyyy');
          e.hour = DateTime.fromFormat(e.dateHour,'yyyy-LL-dd HH:mm:ss',{zone: 'UTC',}).setZone(timezone);
          e.hour = e.hour.setLocale(this.currentLocale).toFormat('HH:mm');
          return e;
          });

    } catch (error) {
      console.log(error);
    } finally {
      this.general.setLoading(false);
    }
    
  } 

  async getGrupalClassesFiltered () {
   
    // console.log('Filtros', this.filters.controls['lesson_id'].value);
    this.active_filters['lesson_id'] = this.filters.controls['lesson_id'].value;
    this.active_filters['date_start'] = this.filters.controls['date_start'].value;
    this.active_filters['date_end'] = this.filters.controls['date_end'].value;
    this.active_filters['language_id'] = this.filters.controls['language_id'].value;

    console.log('Filtros activos', this.active_filters);

    try {
      this.general.setLoading(true);
      const response = await this.general.httpPost(
        'groupal-class-list',
        {
          lesson_id: this.active_filters['lesson_id'],          
          date_start: this.active_filters['date_start'],
          date_end: this.active_filters['date_end'],
          language_id: this.active_filters['language_id'],   
        }
      );
      this.listedClasses = response.message;
      this.listedClasses = this.listedClasses.map((e: any) => { 
        const timezone = this.general.getCurrentTimezone();
        e.date = DateTime.fromFormat(e.dateHour,'yyyy-LL-dd HH:mm:ss',{zone: 'UTC',}).setZone(timezone);
        e.date = e.date.setLocale(this.currentLocale).toFormat('dd-MM-yyyy');
        e.hour = DateTime.fromFormat(e.dateHour,'yyyy-LL-dd HH:mm:ss',{zone: 'UTC',}).setZone(timezone);
        e.hour = e.hour.setLocale(this.currentLocale).toFormat('HH:mm');
        return e;
        });
     
    } catch (error) {
      console.log(error);
    } finally {
      this.general.setLoading(false);
    }
    
  }     
}
